// extracted by mini-css-extract-plugin
export default {"containerWrap":"VoiceCallPanel_containerWrap__Pykav"};